<template>
	<div class="bg-white shadow-sm rounded" style="border: 1px solid rgb(222, 222, 222, 0.5)">
		<div v-if=" isEditMode " class="flex items-center p-3 border-b border-gray-200">
			<div>
				<InplaceEdit
					:inputProps="[{ content: callout.packageTitle, propName: 'packageTitle', inputType: 'input' }]"
					:href="callout._links.self.href" blockTitle="Edit package title">
					<strong class="ml-1">{{ callout.packageTitle }}</strong>
				</InplaceEdit>
			</div>

			<!-- <span v-if=" AppConfig.editmode " class="ml-1 cursor-pointer" v-tooltip.bottom="'Ask Assistant'"
				:id="callout.identifier" icon="tabler:settings" type="editPackage"
				:overrideURL="callout._links.editAll.href">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
					class="icon icon-tabler icons-tabler-outline icon-tabler-user-square-rounded">
					<path stroke="none" d="M0 0h24v24H0z" fill="none" />
					<path d="M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z" />
					<path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
					<path d="M6 20.05v-.05a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v.05" />
				</svg>
			</span> -->

			<div class="ml-auto flex">
				<!-- <div class="">
					<DropdownStatus v-model="selectedTargetAudience" :options="TargetAudience" optionLabel="title"
						@change="updateTargetAudience" value="title"
						class="rounded-e-0  flex flex-row hover:bg-primary-500/80 items-center bg-primary">
						<template #value>
							<div class="flex items-center rounded-s flex flex-row  text-sm text-white">
								{{ selectedTargetAudience?.name }}
							</div>
						</template>
<template #option="slotProps">
							<div class="flex items-center  text-sm !text-dark">
								<div>{{ slotProps.option.name }}</div>
							</div>
						</template>
</DropdownStatus>

</div> -->
				<button v-if=" AppConfig.editmode "
					class="rounded hover:bg-danger-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-danger-500 transition-all bg-danger !text-white mr-2" @click="deleteItem(callout._links.self.href)">
					<i class="tabler:trash w-5 h-5 text-white flex"></i>
				</button>
				<EditButton v-if=" AppConfig.editmode "
					class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white"
					:id="callout.identifier" icon="tabler:settings" type="editPackage"
					:overrideURL="callout._links.editAll.href" />
			</div>
		</div>
		<div class="flex flex-col flex-wrap sm:flex-row justify-center mt-3">
			<div class="mx-4 pt-2 sm:w-12/12 md:w-12/12 lg:w-12/12 mb-3 text-center " v-if=" showGallery ">

				<InteractiveImage alt="Image" preview class="rounded max-h-[360px] overflow-hidden object-contain">
					<template #indicatoricon>
						<i class="tabler:eye w-8 h-8 text-white"></i>
					</template>
					<template #image>
						<EditButton v-if=" AppConfig.editmode "
							class="absolute right-[0px] top-[0px] p-2 z-999 text-white bg-danger rounded hover:bg-danger-200 hover:!text-white"
							:id="callout.identifier" type="imageattr" :overrideURL="callout.illustration[0]?.imageSrcEdit" />

						<img :src="callout.mainOutcome.imageSrc"
							class="img-thumbnail w-100% mx-auto object-cover overflow-hidden md:max-h-100% border"
							alt="image" />
					</template>
					<template #preview="slotProps">
						<div class="p-5 w-[70%] mx-auto">
							<div class="text-mb mb-3 font-bold text-white">
								{{ callout.illustration[0].imageTitle }}
							</div>

							<img :src="callout.mainOutcome.imageSrc" alt="preview" class="mx-auto"
								:style="slotProps.style" @click="slotProps.onClick" />
							<div v-if=" callout.illustration && callout.illustration[0] && callout.illustration[0].imageCopyright "
								class="text-xs mt-3 mb-3 font-bold text-white text-right">
								{{ callout.illustration[0].imageCopyright }}
							</div>
							<div v-if=" callout.illustration && callout.illustration[0] && callout.illustration[0].imageDescription "
								class="text-mb mt-3 mb-3 font-bold text-white">
								{{ callout.illustration[0].imageDescription }}
							</div>
						</div>
					</template>
				</InteractiveImage>
				<div v-if=" callout.illustration && callout.illustration[0] && callout.illustration[0].imageCopyright "
					class="text-[0.56rem] mt-1 mb-1 text-left">
					{{ callout.illustration[0].imageCopyright }}
				</div>
			</div>
			<div class="px-4 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1 relative">
				<EditButton
					class="absolute right-5px top-[-5px] inline-flex items-center gap-2 transition-all rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
					v-if=" AppConfig.editmode && callout._links.mainOutcome " :id="callout.identifier" type="listattr"
					:overrideURL="callout._links.mainOutcome.href" />
				<InplaceEdit
					:inputProps="[{ content: callout.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
					:href="callout._links.mainOutcomeEdit?.href" blockTitle="Edit header">
					<h6
						class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
						{{ callout.mainOutcome.selectHeader }}
					</h6>
				</InplaceEdit>
				<div class="full-content">
					<div class="main-text md:line-clamp-3">
						<div class="flex items-center">
							<InplaceEdit
								:inputProps="[{ content: callout.mainOutcome.title, propName: 'title', inputType: 'textarea' }]"
								:href="callout._links.mainOutcomeEdit?.href" blockTitle="Edit title"
								:textarea-props="{ rows: 3, class: 'min-w-[30rem]' }">
								<RouterLink :to="detailsRoute">
									<h4
										class="mb-2 inline-flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
										{{ callout.mainOutcome.title }}
									</h4>
								</RouterLink>
							</InplaceEdit>
						</div>

						<div class="inline">
							<div
								class="font-sans text-sm font-normal leading-relaxed text-gray-700 antialiased mb-2 line-clamp-2 flex items-center">
								<InplaceEdit
									:inputProps="[{ content: callout.mainOutcome?.publishingDate, propName: 'other.publishingDate', inputType: 'datepicker' }]"
									:href="callout._links.mainOutcomeEdit?.href" blockTitle="Edit publishing date">
									<div class="text-sm">{{ publishingDateFormated }}</div>
								</InplaceEdit>
								<div id="AuthorList" class="flex flex-row items-center">
									<InplaceEdit :inputProps="[{
										content: callout.mainOutcome.authorIdentifier, propName: 'other.authorIdentifier', inputType: 'select', selectProps: {
											optionValue: 'identifier',
											optionLabel: 'title',
											class: 'w-15rem',
											optionsCvKey: 'author'
										}
									}]" :href="callout._links.mainOutcomeEdit?.href" blockTitle="Edit author">
										<div class="ml-2 text-sm font-bold" v-html="callout.mainOutcome.author"> </div>
									</InplaceEdit>
								</div>

							</div>
							<div
								class="flex items-center font-sans text-sm font-normal leading-relaxed text-gray-700 antialiased mb-2 line-clamp-2">
								<div id="editLeadText" class="flex items-end">
									<InplaceEdit
										:inputProps="[{ content: callout.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
										:href="callout._links.mainOutcomeEdit?.href" blockTitle="Edit leadtext">
										<div v-html="callout.mainOutcome.leadText"></div>
									</InplaceEdit>

								</div>
							</div>

							<RouterLink class="flex-1 underline cursor-pointer md:text-sm text-sm" :to="detailsRoute">
								{{ labels.readmode }}
							</RouterLink>
						</div>
					</div>
					<div class="flex items-center">
						<div class="py-3 flex">
							<button type="button"
								class="flex flex-row hover:bg-primary-500/80 items-center rounded py-2 px-3 text-center font-sans mr-2 text-xs font-bold transition-all bg-primary text-white block md:hidden"
								@click="showGallery = !showGallery">
								<i class="tabler:photo-up w-5 h-5"></i>
								<span class="hidden md:inline ml-1">Image</span>
							</button>
						</div>
						<div class="btn-grup flex flex-wrap py-3">
							<button type="button"
								class="flex flex-row hover:bg-primary-500/80 items-center rounded py-2 px-3 mt-3 text-center font-sans mr-2 text-xs font-bold transition-all bg-primary text-white block md:hidden"
								@click="showGallery = !showGallery">
								<i class="tabler:photo-up w-5 h-5"></i>
								<span class="hidden md:inline ml-1">Image</span>
							</button>

							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 mt-3 mr-0 text-center font-sans text-xs font-bold transition-all bg-primary text-white" v-if="callout.mainOutcome.keyMessages"
								:class="{ 'rounded-e mr-2': !AppConfig.editmode }" type="button"
								@click="openKeyMessagesDialog">
								<i class="tabler:list-numbers w-5 h-5 mr-1"></i>
								<span class="hidden md:inline">{{ labels.keymessages }}</span>
							</button>
							<EditButton class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center mt-3 mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							v-if=" AppConfig.editmode && callout._links.mainOutcome && callout.mainOutcome.keyMessages " :id="callout.identifier" type="listattr"
							:overrideURL="callout._links.mainOutcome.href" />
							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
								:class="{ 'rounded-e mr-2': !AppConfig.editmode }" type="button"
								@click="openPreQuizDialog">
								<i class="tabler:list-check w-5 h-5 mr-1"></i>
								<span class="hidden md:inline">{{ labels.prequiz }}</span>
							</button>
							<EditButton v-if=" AppConfig.editmode && callout._links.preQuiz?.href"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 mt-3 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="callout.identifier" type="prequiz" :overrideURL="callout._links.preQuiz?.href" />

							<DialogModal v-if="isModalKeyMessage" :visible="showKeymessagesDialog" maximizable modal :header="labels.keymessages"
								:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
								@update:visible="showKeymessagesDialog = false">
								<EditButton class="absolute right-80px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							v-if=" AppConfig.editmode && callout._links.mainOutcome " :id="callout.identifier" type="listattr"
							:overrideURL="callout._links.mainOutcome.href" />

								<div id="editKeyMessagges" class="flex items-end">
									<InplaceEdit
										:inputProps="[{ content: callout.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
										:href="callout._links.mainOutcomeEdit?.href" blockTitle="Edit key Messages">
										<div v-html="callout.mainOutcome.keyMessages"></div>
									</InplaceEdit>
								</div>
							</DialogModal>
							<SliderPanel
								v-else
								v-model:visible="showKeymessagesDialog"
								:title="labels.keymessages"
								headerStyle="dark"
								size="xl"
								icon="tabler:list-numbers"
								:dismissable="false"
							>
								<div class="h-full overflow-y-auto p-4" id="editKeyMessagges">
									<InplaceEdit
										:inputProps="[{ content: callout.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
										:href="callout._links.mainOutcomeEdit?.href"
										blockTitle="Edit key Messages"
									>
										<div v-html="callout.mainOutcome.keyMessages"></div>
									</InplaceEdit>
								</div>
							</SliderPanel>

							<DialogModal v-if="isModalPreQuiz" :visible="showPrequziDialog" modal :header="labels.prequiz"
								:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
								@update:visible="showPrequziDialog = false">
								<EditButton v-if=" AppConfig.editmode " class="absolute right-53px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
									:id="callout.identifier" type="prequiz" :overrideURL="callout._links.preQuiz.href" />
								<PreQuiz :jsonData="callout" @close="showPrequziDialog = false"
									:overrideURL="callout?._links.preQuiz?.href" :selectedLanguage='selectedLanguage' />
							</DialogModal>
							<SliderPanel
								v-else
								v-model:visible="showPrequziDialog"
								:title="labels.prequiz"
								headerStyle="dark"
								size="xl"
								icon="tabler:list-check"
								:dismissable="false"
							>
								<div class="h-full overflow-y-auto p-4">
									<div v-if="AppConfig.editmode" class="mb-3 flex justify-end">
										<EditButton
											class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="callout.identifier"
											type="prequiz"
											:overrideURL="callout._links.preQuiz.href"
										/>
									</div>
									<PreQuiz
										:jsonData="callout"
										@close="showPrequziDialog = false"
										:overrideURL="callout?._links.preQuiz?.href"
										:selectedLanguage="selectedLanguage"
									/>
								</div>
							</SliderPanel>

							<template v-if=" !isTextOnlyOutput ">
								<PlayerButton :file_url="callout.file_url"
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
									:class="{ 'rounded-e mr-2': !AppConfig.editmode }"
									:language="selectedLanguage" :isPlaying="isPlaying"
									@togglePlayback="emit( 'play', callout.identifier )" />

									<EditButton 
										v-if="AppConfig.editmode"
										class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 mt-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
										
										:id="callout.identifier" 
										type="podcast"
										:overrideURL="callout._links.podcastSlideshowConversations?.href"
									/>

								<button
									v-if="isRoutePresentation"
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center mt-3 font-sans text-xs font-bold transition-all bg-primary text-white"
									:class="{ 'rounded-e': !AppConfig.editmode }"
									type="button" @click="emit( 'toPresentation', callout.identifier || '' )">
									<i class="tabler:presentation w-5 h-5 mr-1"></i>

									<span class="hidden md:inline">{{ labels.presentation }}</span> 
								</button>
								<EditButton
									v-else
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center mt-3 font-sans text-xs font-bold transition-all bg-primary text-white"
									:class="{ 'rounded-e': !AppConfig.editmode }"
									:id="callout.identifier"
									:buttonLabel="`${labels.presentation}`"
									:toolTipLabel="`${labels.presentation}`"
									:headerTitle="callout.mainOutcome.title"
									type="slideshow"
								/>
								<EditButton v-if=" AppConfig.editmode "
									class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans mt-3 text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
									:id="callout.identifier" type="slideshowEdit"
									:overrideURL="callout?._links.podcastSlideshow.href" />
								<!-- <button
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center ml-2 font-sans text-xs font-bold transition-all bg-primary text-white"
									type="button" @click="">
									<i class="tabler:file w-5 h-5 mr-1"></i>

									<span class="hidden md:inline">{{ labels.document }}</span>
								</button> -->
								<EditButton
									class="rounded flex flex-row hover:bg-primary-500/80 mt-3 items-center ml-2 py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
									v-if="showFeedbackButton"
									:modal="isModalFeedback"
									:id="callout.identifier" type="feedback"
									:overrideURL="AppConfig.urls.feedback?.url" />
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if=" isEditMode " class="flex items-center p-3 border-t border-gray-200">
			<!-- <DropdownStatus v-model="selectedAssistant" :options="assistantList" optionLabel="title"
				@change="updateAssistant" value="title"
				class="rounded-s rounded-e-0  flex flex-row hover:bg-primary-500/80 items-center bg-primary">
				<template #value>
					<div class="flex items-center rounded-s flex flex-row  text-sm text-white">
						<i class="tabler:message-2-question w-5 h-5 mr-2"></i>
						{{ selectedAssistant?.name }}
					</div>
				</template>
				<template #option="slotProps">
					<div class="flex items-center  text-sm !text-dark">
						<div>{{ slotProps.option.name }}</div>
					</div>
				</template>
			</DropdownStatus>
			<EditButton v-if=" AppConfig.editmode "
				class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
				:id="callout.identifier" icon="tabler:message-2-question" type="askAssistant" /> -->


				<div v-if=" !AppConfig.models " class="ml-auto flex items-center">
				<EditButton v-if=" AppConfig.editmode && callout.assistantStatus === 'in progress'" class="flex items-center gap-2 mr-2 border rounded px-2 py-[6.5px] border-danger text-danger"
				:id="callout.identifier" type="assistantMode"
				:overrideURL="callout._links?.assistantProcessingLink?.href"
				/>
				<AuthoringStatus v-if="callout.assistantStatus !== 'in progress'" v-tooltip.top="'Package Authoring Status'" class="mr-2" :uid="callout.identifier"
					:jsonData="callout" :optionLabel="callout.authoringStatusCode"
					:statusOptions="authoringStatusOptions"

					:optionValue="callout.authoringStatusCode" :key="callout.identifier"
					@statusChange="authoringStatusChange" />

				<PublishingStatus v-if="callout.assistantStatus !== 'in progress'" v-tooltip.top="'Package Publishing Status'" :uid="callout.identifier"
					:jsonData="callout" :optionLabel="callout.publishingStatusCode" :lng="selectedLanguage"
					:statusOptions="publishingStatusOptions"
					:optionValue="callout.publishingStatusCode" :key="callout.identifier"
					@statusChange="publishingStatusChange" />
			</div>

		</div>

	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { DateTime } from "luxon";

import { useAppConfig } from '@/composables/useAppConfig';
import type { Callout, LanguageCodes } from '@/types'
import { messages } from '@/assets/language';
import { useRouter } from 'vue-router'
import EditButton from '@/components/EditButton.vue'
import PreQuiz from '@/components/PreQuiz.vue'
import PlayerButton from '@/components/PlayerButton.vue'
import AuthoringStatus from '@/components/AuthoringStatus.vue'
import PublishingStatus from '@/components/PublishingStatus.vue'
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue'
import SliderPanel from '@/components/SidebarPanel/SidebarPanel.vue'


const props = withDefaults( defineProps<{
	callout: Callout;
	isTextOnlyOutput?: boolean
	isPlaying?: boolean
	isEditMode?: boolean
	selectedLanguage?: LanguageCodes
	authoringStatusOptions?: Array<{ identifier: string; title: string }>;
	publishingStatusOptions?: Array<{ identifier: string; title: string }>;
	
}>(), {
	isTextOnlyOutput: false,
	isPlaying: false,
	isEditMode: false,
	selectedLanguage: 'de'
} )

const emit = defineEmits<{
	play: [Callout['identifier']]
	toPresentation: [Callout['identifier']]
	authoringStatusChange: [Callout['authoringStatusCode']]
	publishingStatusChange: [Callout['publishingStatusCode']]
	titleUpdate: ['title-update']
	delete:[string]
}>()
const AppConfig = useAppConfig();


const deleteItem = (url: string) => {
  console.log('Deleting item:', url);
  emit('delete', url);
};

const showFeedbackButton = computed(() => AppConfig.urls.feedback?.enabled === true)
const isModalFeedback = computed(() => AppConfig.urls.feedback?.modal === true)
const isModalPreQuiz = computed(() => AppConfig.urls.prequiz?.modal === true)
const isModalKeyMessage = computed(() => AppConfig.urls.keymessage?.modal === true)
const resolveOpenMode = (value: string | null | undefined): 'modal' | 'route' =>
	value === 'route' ? 'route' : 'modal'
const isRoutePreQuiz = computed(() => resolveOpenMode(AppConfig.urls.prequiz?.openMode) === 'route')
const isRouteKeyMessage = computed(() => resolveOpenMode(AppConfig.urls.keymessage?.openMode) === 'route')
const isRoutePresentation = computed(() => resolveOpenMode(AppConfig.urls.presentation?.openMode) === 'route')



const router = useRouter();

const selectedTargetAudience = ref();

const TargetAudience = ref( [
	{ name: 'GP - General Practitioner', code: 'gp' },
	{ name: 'Health Service Consumer', code: 'hs' },
	{ name: 'Medical Specialist', code: 'ms' },
] );


selectedTargetAudience.value = TargetAudience.value[0];

const publishingDateFormated = computed(() => {
	const publishingDate = props.callout?.mainOutcome?.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});


const selectedAssistant = ref();

const assistantList = ref( [
	{ name: 'Screening Assistant', code: 'as1' },
	{ name: 'Authoring Assistant', code: 'as2' },
	{ name: 'Quiz Assistant', code: 'as3' },
	{ name: 'Multimedia Assistant', code: 'as4' },
	{ name: 'Reviewer Assistant', code: 'as5' },
	{ name: 'Publishing Assistant', code: 'as6' },
] );
selectedAssistant.value = assistantList.value[0];

const updateAssistant = () => {
	console.log( 'Opsioni i selektuar:', selectedAssistant.value );
};


const showPrequziDialog = ref( false )
const showKeymessagesDialog = ref( false )
const showGallery = ref( true )

const stopInlineAudio = () => {
	window.dispatchEvent(new CustomEvent('stop-inline-audio'));
};

const goToDetailsWithOpen = (target: 'prequiz' | 'keymessage') => {
	const nextLng = String(props.selectedLanguage ?? '').trim()
	router.push({
		name: 'details',
		params: { id: props.callout.identifier },
		query: {
			...router.currentRoute.value.query,
			...(nextLng ? { lng: nextLng } : {}),
			open: target
		}
	});
};

const openPreQuizDialog = () => {
	stopInlineAudio();
	if (isRoutePreQuiz.value) {
		goToDetailsWithOpen('prequiz');
		return;
	}
	showPrequziDialog.value = true;
};

const openKeyMessagesDialog = () => {
	stopInlineAudio();
	if (isRouteKeyMessage.value) {
		goToDetailsWithOpen('keymessage');
		return;
	}
	showKeymessagesDialog.value = true;
};

const labels = computed( () => messages[props.selectedLanguage] );

const detailsRoute = computed( () => {
	return { name: 'details', params: { ...router.currentRoute.value.params, id: props.callout.identifier }, query: { ...router.currentRoute.value.query } }
} )

function authoringStatusChange ( newStatus: Callout['authoringStatusCode'] ) {
	emit( 'authoringStatusChange', newStatus )
}

function publishingStatusChange ( newStatus: Callout['publishingStatusCode'] ) {
	emit( 'publishingStatusChange', newStatus )
}


onBeforeUnmount(() => {
  sessionStorage.setItem('listScrollPosition', window.scrollY.toString());
});

onMounted(() => {
  const savedScroll = sessionStorage.getItem('listScrollPosition');
  if (savedScroll) {
    setTimeout(() => {
      window.scrollTo({
        top: parseInt(savedScroll),
        behavior: 'auto'
      });
      sessionStorage.removeItem('listScrollPosition');
    }, 50); // delay i vogël për të pritur DOM-in
  }
});


</script>

<style>
.p-tooltip {
	font-size: 13px;
}

.p-inplace-display {
	display: flex;
	padding: 0;
	margin: 0;
}

#leadText .p-inplace-display {
	display: flex;
	padding: 0;
	margin: 0;
	align-items: end;
}

.drop-zone {
	border: 2px dashed #ccc;
	padding: 20px;
	margin: 10px 0;
	text-align: center;
	cursor: pointer;
}

.image-zone img {
	max-width: 100%;
	height: auto;
}

.spinnerAssistant {
   width: 24px;
   height: 24px;
   border-radius: 50%;
   border: 3px solid;
   border-color: transparent;
   border-left-color: var(--danger);
   border-right-color: var(--danger);
   animation: spinner-d3wgkg 1s infinite linear;
}

@keyframes spinner-d3wgkg {
   to {
      transform: rotate(1turn);
   }
}

#editKeyMessages ol{
    list-style: decimal-leading-zero;
    margin: 0 1em;
    padding: 0 20px 0 20px;
}
#editKeyMessages ul, #editKeyMessages menu {
    list-style: disc;
    margin: 0 1em;
    padding: 0 20px 0 20px;
}
.p-dropdown-panel .p-dropdown-items {
    padding: 0.25rem 0.25rem;
}
</style>
